import * as FilePond from "filepond";
import Splide from '@splidejs/splide'
import {Alert} from '../functions';
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'
import $ from 'jquery'

const object = vnObject

document.addEventListener('DOMContentLoaded', (event) => {
    let noAccountCvPond = false;
    const cvEl = document.querySelector('.js-cv-input')
    noAccountCvPond = FilePond.create(cvEl, {
        acceptedFileTypes: [
            'application/pdf',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/jpeg',
            'image/png',
            'application/vnd.oasis.opendocument.text',
            'application/vnd.oasis.opendocument.text-template'
        ],
        fileValidateTypeLabelExpectedTypesMap: {
            'application/pdf': '.pdf',
            'application/msword': '.doc',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
            'image/jpeg': '.jpg, .jpeg',
            'image/png': '.png',
            'application/vnd.oasis.opendocument.text': '.odt',
            'application/vnd.oasis.opendocument.text-template': '.fodt, .ppg'
        },
        fileValidateTypeLabelExpectedTypes: 'Expects {allButLastType} or {lastType}',
        instantUpload: false
    });

    $(cvEl).hide()

    $('#have_cv').on('change', function () {
        if ($(this).is(':checked')) {
            $('.js-cv-input').slideDown();
        } else {
            $('.js-cv-input').slideUp();
        }
    });

    $('#create_account').on('change', function () {
        if ($(this).is(':checked')) {
            $('.js-password-input').slideDown();
        } else {
            $('.js-password-input').slideUp();
        }
    });

    const form = $('.js-particular-spontaneous-application')

    if (form.length) {
        form.parsley().on('form:success', function () {
            form.attr('data-success', 'true')
        })

        form.parsley().on('form:error', function () {
            form.attr('data-success', 'false')
        })

        form.on('submit', function (e) {
            e.preventDefault()
            e.stopPropagation()

            const formData = new FormData(form[0])
            formData.append('action', 'vn_spontaneous_application')
            formData.append('nonce', object.nonce)

            const pondFiles = noAccountCvPond.getFiles();
            if (pondFiles[0]) {
                formData.append('cv', pondFiles[0].file);
            }

            const $form = form
            $.ajax({
                url: object.ajaxUrl,
                type: 'POST',
                data: formData,
                beforeSend: () => {
                    $form.addClass('sending')
                    Alert('warning', object.formWait, false)
                },
                processData: false,
                contentType: false,
                success: (res) => {
                    $form.removeClass('sending')

                    Alert(res.success, res.data.message)
                    res.success && $form[0].reset()
                },
            })
        })
    }


    if (document.body.classList.contains('page-template-page-template-spontaneous-application')) {
        const splide = new Splide('.s-jobs__slider', {
            drag: 'free',
            gap: '30px',
            arrows: false,
            pagination: false,
            breakpoints: {
                992: {
                    perPage: 1,
                },
            },
        })

        splide.mount()
    }
});
